import { WarningIcon } from "@phosphor-icons/react/dist/csr/Warning";
import { XCircleIcon } from "@phosphor-icons/react/dist/csr/XCircle";
import { Alert, AlertDescription } from "@volca/ui/components/ui/alert";
import { Button } from "@volca/ui/components/ui/button";
import { Spinner } from "@volca/ui/components/ui/spinner";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { getErrorMessage } from "@/core/api/errors";

export const DeliveryPollingBanner = ({
  error,
  pollingTimedOut,
  isRefreshing,
  onCheckAgain,
}: {
  error: unknown;
  pollingTimedOut: boolean;
  isRefreshing: boolean;
  onCheckAgain: () => void;
}) => {
  if (!error && !pollingTimedOut) return null;

  return (
    <Alert
      color={error ? "danger" : "warning"}
      role={error ? "alert" : "status"}
    >
      {error ? <XCircleIcon /> : <WarningIcon />}
      <AlertDescription>
        <Stack direction="row" align="center" justify="between" gap={4}>
          <Stack align="start" gap={1}>
            <Text variant="caption">
              {error
                ? "Couldn't update the delivery statuses."
                : "Delivery updates are taking longer than expected."}
            </Text>
            <Text tone="muted">
              {error
                ? getErrorMessage(error)
                : "The latest known statuses are shown below."}
            </Text>
          </Stack>
          <Button
            size="sm"
            variant="secondary"
            onClick={onCheckAgain}
            disabled={isRefreshing}
            aria-busy={isRefreshing || undefined}
          >
            {isRefreshing && <Spinner data-icon="inline-start" aria-hidden />}
            Check again
          </Button>
        </Stack>
      </AlertDescription>
    </Alert>
  );
};
